import {
  caseFormSections,
  formFieldTypes,
  formFieldKeys,
  formFieldAllowedInputs,
  caseFormSectionsLabels,
  newObjects,
  typeKeys,
} from '@messenger/consts'
import type { CaseForm } from '@messenger/types'

export const caseForm: CaseForm = {
  [caseFormSections.personalInfo]: [
    {
      key: formFieldKeys.sectionLabel,
      type: formFieldTypes.sectionLabel,
      label: caseFormSectionsLabels.personalInfo,
    },
    {
      key: formFieldKeys.editableCaseId,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.editableCaseId,
    },
    {
      key: formFieldKeys.prefix,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.prefix,
    },
    {
      key: formFieldKeys.firstName,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.firstName,
    },
    {
      key: formFieldKeys.nickName,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.nickName,
    },
    {
      key: formFieldKeys.middleName,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.middleName,
    },
    {
      key: formFieldKeys.maidenName,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.maidenName,
    },
    {
      key: formFieldKeys.lastName,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.lastName,
    },
    {
      key: formFieldKeys.suffix,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.suffix,
    },
    {
      key: formFieldKeys.dateOfBirth,
      type: formFieldTypes.date,
      label: caseFormSectionsLabels.dateOfBirth,
    },
    {
      key: formFieldKeys.dateOfDeath,
      type: formFieldTypes.date,
      label: caseFormSectionsLabels.dateOfDeath,
    },
    {
      key: formFieldKeys.placeOfBirth,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.placeOfBirth,
    },
    {
      key: formFieldKeys.placeOfDeath,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.placeOfDeath,
    },
  ],
  [caseFormSections.familyInfo]: [
    {
      key: formFieldKeys.sectionLabel,
      type: formFieldTypes.sectionLabel,
      label: caseFormSectionsLabels.parents,
    },
    {
      key: formFieldKeys.motherOfDeceased,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.motherOfDeceased,
    },
    {
      key: formFieldKeys.fatherOfDeceased,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.fatherOfDeceased,
    },
    {
      key: formFieldKeys.sectionLabel,
      type: formFieldTypes.sectionLabel,
      label: caseFormSectionsLabels.spouse,
    },
    {
      key: formFieldKeys.spouse,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.spouse,
    },
    {
      key: formFieldKeys.siblings,
      type: formFieldTypes.array,
      label: caseFormSectionsLabels.siblings,
      shortLabel: caseFormSectionsLabels.sibling,
    },
    {
      key: formFieldKeys.children,
      type: formFieldTypes.array,
      label: caseFormSectionsLabels.children,
      shortLabel: caseFormSectionsLabels.child,
    },
  ],
  [caseFormSections.additionalFamily]: [
    {
      key: formFieldKeys.sectionLabel,
      type: formFieldTypes.sectionLabel,
      label: caseFormSectionsLabels.additionalFamily,
    },
    {
      key: formFieldKeys.additionalFamily,
      type: formFieldTypes.mappedArray,
      typeKeys: null,
      addCaseAndType: true,
      keyMappingRequired: true,
      addLabel: caseFormSectionsLabels.addAnotherGroup,
      addPlaceholder: caseFormSectionsLabels.precededBySurvivedByGrandchildren,
      allowedInputs: formFieldAllowedInputs.additionalFamily,
      newObject: newObjects.additionalFamily,
    },
  ],
  [caseFormSections.serviceInfo]: [
    {
      key: formFieldKeys.services,
      type: formFieldTypes.nestedArray,
      typeKeys: [typeKeys.visitation, typeKeys.service],
      addCaseAndType: true,
      allowedInputs: formFieldAllowedInputs.services,
      newObject: newObjects.service,
    },
    {
      key: formFieldKeys.orderOfService,
      type: formFieldTypes.textarea,
      label: caseFormSectionsLabels.orderOfService,
    },
    {
      key: formFieldKeys.clergy,
      type: formFieldTypes.array,
      label: caseFormSectionsLabels.clergy,
      shortLabel: caseFormSectionsLabels.clergy,
    },
  ],
  [caseFormSections.musicSelections]: [
    {
      key: formFieldKeys.songs,
      type: formFieldTypes.array,
      label: caseFormSectionsLabels.musicSelections,
      shortLabel: caseFormSectionsLabels.song,
    },
  ],
  [caseFormSections.pallBearersSocieties]: [
    {
      key: formFieldKeys.pallbearers,
      type: formFieldTypes.nestedArray,
      typeKeys: [typeKeys.pallbearer, typeKeys.honoraryPallbearer],
      addCaseAndType: true,
      allowedInputs: formFieldAllowedInputs.pallbearers,
      newObject: {
        name: null,
        sequence: null,
      },
    },
    {
      key: formFieldKeys.organizations,
      type: formFieldTypes.nestedArray,
      typeKeys: [typeKeys.organization],
      addCaseAndType: false,
      allowedInputs: formFieldAllowedInputs.organizations,
      newObject: {
        name: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip_code: null,
        country: null,
        website_url: null,
        sequence: null,
      },
    },
  ],
  [caseFormSections.intermentInfo]: [
    {
      key: formFieldKeys.sectionLabel,
      type: formFieldTypes.sectionLabel,
      label: caseFormSectionsLabels.intermentInfo,
    },
    {
      key: formFieldKeys.intermentTime,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.intermentTime,
    },
    {
      key: formFieldKeys.intermentDate,
      type: formFieldTypes.date,
      label: caseFormSectionsLabels.intermentDate,
    },
    {
      key: formFieldKeys.intermentPlace,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.intermentPlace,
    },
    {
      key: formFieldKeys.intermentAddress,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.intermentAddress,
    },
    {
      key: formFieldKeys.intermentCity,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.intermentCity,
    },
    {
      key: formFieldKeys.intermentState,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.intermentState,
    },
    {
      key: formFieldKeys.intermentPostalCode,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.intermentPostalCode,
    },
  ],
  [caseFormSections.memorialContributions]: [
    {
      key: formFieldKeys.memorialContributions,
      type: formFieldTypes.nestedArray,
      typeKeys: [typeKeys.memorialContribution],
      addCaseAndType: false,
      allowedInputs: formFieldAllowedInputs.memorialContributions,
      newObject: newObjects.memorialContributions,
    },
  ],
  [caseFormSections.headers]: [
    {
      key: formFieldKeys.birthHeader,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.birthHeader,
    },
    {
      key: formFieldKeys.deathHeader,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.deathHeader,
    },
    {
      key: formFieldKeys.remembranceHeader,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.remembranceHeader,
    },
    {
      key: formFieldKeys.officiatingHeader,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.officiatingHeader,
    },
    {
      key: formFieldKeys.memorialServiceHeader,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.memorialServiceHeader,
    },
    // Pallbearers/Visitation headers hidden: https://builtbyhq.slack.com/archives/C07GZ2JJL9F/p1770068983844759?thread_ts=1769464186.107739&cid=C07GZ2JJL9F
    {
      key: formFieldKeys.finalRestingHeader,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.finalRestingHeader,
    },
    {
      key: formFieldKeys.familyAppreciationHeader,
      type: formFieldTypes.input,
      label: caseFormSectionsLabels.familyAppreciationHeader,
      m3Only: true,
    },
  ],
}

export default caseForm
